module.exports = __webpack_public_path__ + "assets/img/learning3.c98e464b.png";